import { denormalize } from "normalizr";
import { group } from "../../../api/schema";

export default id => state => {
  try {
    const denormalized = denormalize(
      { item: id },
      { item: group },
      state.entities
    );

    return denormalized.item || {};
  } catch (err) {
    return {};
  }
};
